// extracted by mini-css-extract-plugin
export default {"navbarMobile":"nav-bar-mobile_navbarMobile__vpByK","menu":"nav-bar-mobile_menu__QRVHn","title":"nav-bar-mobile_title__MGh+3"};